<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns" stripe highlight-row
            border @on-current-change="onSelectionTableChange"></Table>
        <Row style="padding:10px 0px 0px 0px">
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="success" @click="onClickInsert">添加{{typeName}}</Button>
            </Col>
            <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="warning" @click="onClickUpdate">修改{{typeName}}</Button>
            </Col>
            <!-- <Col span=3 style="padding:0px 5px 0px 0px">
            <Button long type="error" @click="onClickDelete">删除{{typeName}}</Button>
            </Col> -->
            <Col span=15>
            <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
                @on-page-size-change="changePageSize" style="text-align:right"></Page>
            </Col>
        </Row>

        <!-- 模态框insert -->
        <Modal v-model="isShowInsertModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>添加{{typeName}}</span>
            </p>
            <Form ref="formInsert" :label-width="110" :rules="ruleInsert" :model="formInsert">
                <FormItem prop="meterTypeName" label="设备类型名称：">
                    <Input v-model="formInsert.meterTypeName" placeholder="请输入设备类型名称..."></Input>
                </FormItem>
                <FormItem prop="meterTypePayType" label="设备支付类型：">
                    <Input v-model="formInsert.meterTypePayType" placeholder="请输入设备支付类型..."></Input>
                </FormItem>
                <FormItem prop="meterTypeRemark" label="备注：">
                    <Input v-model="formInsert.meterTypeRemark" placeholder="请输入备注..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
            </div>
        </Modal>

        <!-- 模态框update -->
        <Modal v-model="isShowUpdateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ff9900;text-align:center">
                <Icon type="md-create" />
                <span>修改{{typeName}}</span>
            </p>
            <Form ref="formUpdate" :label-width="110" :rules="ruleInsert" :model="formUpdate">
                <FormItem prop="meterTypeName" label="设备类型名称：">
                    <Input v-model="formUpdate.meterTypeName" placeholder="请输入设备类型名称..."></Input>
                </FormItem>
                <FormItem prop="meterTypePayType" label="设备支付类型：">
                    <Input v-model="formUpdate.meterTypePayType" placeholder="请输入设备支付类型..."></Input>
                </FormItem>
                <FormItem prop="meterTypeRemark" label="备注：">
                    <Input v-model="formUpdate.meterTypeRemark" placeholder="请输入备注..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
            </div>
        </Modal>

        <!-- 模态框delete -->
        <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#ed4014;text-align:center">
                <Icon type="md-create" />
                <span>删除{{typeName}}</span>
            </p>
            <div style="color:#ed4014;text-align:center">
                是否确认删除所选{{typeName}}？
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.showColumns = [{
                    title: "id",
                    key: "meterTypeId"
                },
                {
                    title: "设备类型名称",
                    key: "meterTypeName"
                },
                {
                    title: "设备类型支付方式",
                    key: "meterTypePayType"
                },
                {
                    title: "设备类型备注",
                    key: "meterTypeRemark"
                }
            ];
            this.showPage();
        },
        data() {
            const validatePayType = (rule, value, callback) => {
                if (value.length === 0 ||
                    (value.indexOf('金额') == -1 &&
                        value.indexOf('流量') == -1) ||
                    (value.indexOf('金额') > -1 &&
                        value.indexOf('流量') > -1)) {
                    callback(new Error('请输入设备支付类型（金额或流量）...'));
                } else {
                    callback();
                }
            };
            return {
                typeName: "设备类型",
                urlClass: "meterType",
                height: window.innerHeight,
                isSpinShow: false,
                isLoadingButton: false,
                isShowInsertModal: false,
                isShowUpdateModal: false,
                isShowDeleteModal: false,
                isShowTarget: false,
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [],
                selectedData: null,
                formInsert: {
                    meterTypeName: "",
                    meterTypePayType: "",
                    meterTypeRemark: ""
                },
                formUpdate: {
                    meterTypeName: "",
                    meterTypePayType: "",
                    meterTypeRemark: ""
                },
                ruleInsert: {
                    meterTypeName: [{
                        required: true,
                        message: '请输入设备名称...',
                        trigger: 'blur'
                    }],
                    meterTypePayType: [{
                        required: true,
                        validator: validatePayType,
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            onSelectionTableChange(currentRow) {
                this.selectedData = currentRow;
            },
            onClickInsert() {
                this.isShowInsertModal = true;
            },
            onClickUpdate() {
                if (this.selectedData) {
                    this.formUpdate = this.selectedData;
                    this.isShowUpdateModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickDelete() {
                if (this.selectedData) {
                    this.isShowDeleteModal = true;
                } else {
                    this.$Notice.warning({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            commitInsert() {
                let that = this;
                that.$refs['formInsert'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/" + that.urlClass + "/insert",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(that.formInsert),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    that.isLoadingButton = false;
                                    that.isShowInsertModal = false;
                                    return;
                                }
                                that.isLoadingButton = false;
                                that.isShowInsertModal = false;
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                                that.isLoadingButton = false;
                                that.isShowInsertModal = false;
                            }
                        });
                    }
                });
            },
            commitUpdate() {
                let that = this;
                that.$refs['formUpdate'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/" + that.urlClass + "/update",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(that.formUpdate),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    that.isLoadingButton = false;
                                    that.isShowUpdateModal = false;
                                    return;
                                }
                                that.isLoadingButton = false;
                                that.isShowUpdateModal = false;
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                                that.isLoadingButton = false;
                                that.isShowUpdateModal = false;
                            }
                        });
                    }
                });
            },
            commitDelete() {
                let that = this;
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/" + that.urlClass + "/delete",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.selectedData),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isLoadingButton = false;
                            that.isShowDeleteModal = false;
                            return;
                        }
                        that.isLoadingButton = false;
                        that.isShowDeleteModal = false;
                        that.showPage();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                        that.isLoadingButton = false;
                        that.isShowDeleteModal = false;
                    }
                });
            },
            showPage() {
                let that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/" + that.urlClass + "/selectPage?page=" +
                        this.currentPage +
                        "&pageAmount=" +
                        this.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({}),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isSpinShow = false;
                            return;
                        }
                        that.showData = data.body.resultList;
                        that.dataCount = data.body.amount;
                        that.isSpinShow = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                        that.isSpinShow = false;
                    }
                });
            },
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            }
        }
    }
</script>

<style>
</style>
